import './App.css';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Setup Amrit's iframe
    const amritUrl = "https://app-dev.happyverse.ai/amrit_rao_confidant";
    const amritElement = document.getElementById("happyverse-widget-embed-amrit");

    if (amritElement && !amritElement.querySelector('iframe')) {
      const aspectRatio = 960 / 640;
      amritElement.style.cssText = "width: 100%; max-width: 960px; min-width: 120px; aspect-ratio: 1.5; border-radius: 8px; overflow: hidden; border: 2px solid #ddd; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); margin: 20px auto; display: block;";

      const amritIframe = document.createElement("iframe");
      amritIframe.src = amritUrl;
      amritIframe.allow = "microphone; camera; fullscreen; autoplay; display-capture";
      amritIframe.style.cssText = "width: 100%; height: 100%; border: none; margin: 0; padding: 0; display: block; object-fit: cover;";
      amritIframe.title = "Happyverse AI Confidant";
      amritIframe.allowFullscreen = true;

      const amritLoadingDiv = document.createElement("div");
      amritLoadingDiv.style.cssText = "position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);color: #666;font-size: 16px;z-index: 1;";
      amritLoadingDiv.textContent = "Loading Happyverse...";

      amritElement.style.position = "relative";
      amritElement.appendChild(amritLoadingDiv);
      amritElement.appendChild(amritIframe);

      amritIframe.addEventListener("load", function() {
        if (amritLoadingDiv.parentNode) {
          amritLoadingDiv.parentNode.removeChild(amritLoadingDiv);
        }
      });
    }

    // Setup Alejandra's iframe
    const alejandraUrl = "https://app-dev.happyverse.ai/ale_vergara_vc_pitch_mentor";
    const alejandraElement = document.getElementById("happyverse-widget-embed-alejandra");

    if (alejandraElement && !alejandraElement.querySelector('iframe')) {
      const aspectRatio = 960 / 640;
      alejandraElement.style.cssText = "width: 100%; max-width: 960px; min-width: 120px; aspect-ratio: 1.5; border-radius: 8px; overflow: hidden; border: 2px solid #ddd; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); margin: 20px auto; display: block;";

      const alejandraIframe = document.createElement("iframe");
      alejandraIframe.src = alejandraUrl;
      alejandraIframe.allow = "microphone; camera; fullscreen; autoplay; display-capture";
      alejandraIframe.style.cssText = "width: 100%; height: 100%; border: none; margin: 0; padding: 0; display: block; object-fit: cover;";
      alejandraIframe.title = "Happyverse AI Confidant";
      alejandraIframe.allowFullscreen = true;

      const alejandraLoadingDiv = document.createElement("div");
      alejandraLoadingDiv.style.cssText = "position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);color: #666;font-size: 16px;z-index: 1;";
      alejandraLoadingDiv.textContent = "Loading Happyverse...";

      alejandraElement.style.position = "relative";
      alejandraElement.appendChild(alejandraLoadingDiv);
      alejandraElement.appendChild(alejandraIframe);

      alejandraIframe.addEventListener("load", function() {
        if (alejandraLoadingDiv.parentNode) {
          alejandraLoadingDiv.parentNode.removeChild(alejandraLoadingDiv);
        }
      });
    }

    // Cleanup function
    return () => {
      if (amritElement) {
        amritElement.innerHTML = '';
      }
      if (alejandraElement) {
        alejandraElement.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="App">
      <header className="header">
        <img src="/happyverse-logo-black.svg" alt="Happyverse" className="logo" />
        <h1>VC Playground</h1>
      </header>

      <main className="main-content">
        <div className="card">
          <h2 className="card-title">Amrit, Village Global</h2>
          <div className="card-content">
            <div id="happyverse-widget-embed-amrit"></div>
          </div>
        </div>

        <div className="card">
          <h2 className="card-title">Alejandra, Bee Partners</h2>
          <div className="card-content">
            <div id="happyverse-widget-embed-alejandra"></div>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>Pitch your idea by joining the room and sharing your 1-pager to get started, and receive immediate feedback</p>
      </footer>
    </div>
  );
}

export default App;
